/* eslint-disable */
// /* eslint-disable no-unreachable */
// /* eslint-disable consistent-return */
// /* eslint-disable array-callback-return */
// /* eslint-disable no-return-assign */
import P from 'prop-types';
import { useState, useContext, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Button } from '@material-ui/core';
import { ButtonMenu, SubMenu, Shadow } from './styles';
import { MainContext } from '../../../context/ApiContext';
import ItemSubMenu from '../ItemSubMenu';

export default function MenuButton({ count, subCount, name, onClick, className, user, onChangeFlow, status, index }) {
  const [chanelClick, setChanelClick] = useState(null);
  const [open, setOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(false);

  function countChannel(channel) {
    if (channel.id == 3 || channel.id == 2 || channel.id == 21 || channel.children?.length > 0) {
      let varTotal = 0;
      subCount.forEach((e) => {
        // console.log(user.technical_team.channels.some((cha)=> cha.id == e.id));
        if (channel?.children.some((ch) => ch.id == e.id)) {
          varTotal += user.technical_team.channels.some((cha) => cha.id == e.id) ? parseInt(e.total) : 0;
        }
      });
      return parseInt(varTotal);
    }
    return subCount?.find((c) => c.id == channel.id)?.total;
  }
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const GrupoCarbel = () => (
    <>
      <li className="item">
        <Button
          fullWidth
          onClick={() => {
            if (onChangeFlow != null) {
              localStorage.setItem('pessego_attendance_flow', JSON.stringify([1, 8, 9, 10, 2, 3, 4, 5, 6, 7]));
              onChangeFlow([1, 8, 9, 10, 2, 3, 4, 5, 6, 7]);
            }
            onClick(1, 1);
            setOpen(false);
            setOpenSubMenu(false);
          }}>
          VN <span className="count">{subCount?.find((c) => c.id == 1)?.vn ?? 0}</span>
        </Button>
      </li>
      <li className="item">
        <Button
          fullWidth
          onClick={() => {
            if (onChangeFlow != null) {
              localStorage.setItem('pessego_attendance_flow', JSON.stringify([1, 8, 9, 10, 2, 3, 4, 5, 6, 7]));
              onChangeFlow([1, 8, 9, 10, 2, 3, 4, 5, 6, 7]);
            }
            onClick(1, 2);
            setOpen(false);
            setOpenSubMenu(false);
          }}>
          VU <span className="count">{subCount?.find((c) => c.id == 1)?.vu ?? 0}</span>
        </Button>
      </li>
      <li className="item">
        <Button
          fullWidth
          onClick={() => {
            if (onChangeFlow != null) {
              localStorage.setItem('pessego_attendance_flow', JSON.stringify([1, 8, 9, 10, 2, 3, 4, 5, 6, 7]));
              onChangeFlow([1, 8, 9, 10, 2, 3, 4, 5, 6, 7]);
            }
            onClick(1, 3);
            setOpen(false);
            setOpenSubMenu(false);
          }}>
          VD <span className="count">{subCount?.find((c) => c.id == 1)?.vd ?? 0}</span>
        </Button>
      </li>
    </>
  );

  //#region Checa se o usuário tem technical_team e se o channel pertence ao team do mesmo
  const Web = ({ WebChildren }) => (
    <>
      {WebChildren.map(
        (wc) =>
          !user.technical_team ||
          (user.technical_team && user.technical_team.channels.filter((tt) => tt.id == wc.id).length > 0 && (
            <li key={wc.id} className="item">
              <Button
                fullWidth
                onClick={() => {
                  if (onChangeFlow != null) {
                    localStorage.setItem('pessego_attendance_flow', JSON.stringify(wc.attendance_flow.status_flow));
                    onChangeFlow(wc.attendance_flow.status_flow);
                  }
                  onClick(wc.id, null);
                  setOpen(false);
                  setOpenSubMenu(false);
                }}>
                {wc.name} <span className="count">{countChannel(wc) ?? 0}</span>
              </Button>
            </li>
          ))
      )}
    </>
  );
  const Partners = ({ PartnersChildren }) => (
    <>
      {PartnersChildren.map(
        (pc) =>
          !user?.technical_team ||
          (user?.technical_team && user?.technical_team.channels.filter((tt) => tt.id == pc.id).length > 0 && (
            <li key={pc.id} className="item">
              <Button
                fullWidth
                onClick={() => {
                  if (onChangeFlow != null) {
                    localStorage.setItem('pessego_attendance_flow', JSON.stringify(pc.attendance_flow.status_flow));
                    onChangeFlow(pc.attendance_flow.status_flow);
                  }
                  onClick(pc.id, null);
                  setOpen(false);
                  setOpenSubMenu(false);
                }}>
                {pc.name} <span className="count">{countChannel(pc) ?? 0}</span>
              </Button>
            </li>
          ))
      )}
    </>
  );
  const SubChannel = ({ subChildren }) => (
    <>
      {subChildren.map(
        (cac) =>
          !user?.technical_team ||
          (user?.technical_team && user?.technical_team.channels.filter((tt) => tt.id == cac.id).length > 0 && (
            <li key={cac.id} className="item">
              <Button
                fullWidth
                onClick={() => {
                  if (onChangeFlow != null) {
                    localStorage.setItem('pessego_attendance_flow', JSON.stringify(cac.attendance_flow.status_flow));
                    onChangeFlow(cac.attendance_flow.status_flow);
                  }
                  onClick(cac.id, null);
                  setOpen(false);
                  setOpenSubMenu(false);
                }}>
                {cac.name} <span className="count">{countChannel(cac) ?? 0}</span>
              </Button>
            </li>
          ))
      )}
    </>
  );
  //#endregion

  return (
    <>
      <div style={{ position: 'relative' }}>
        <ButtonMenu
          className={`${className} ${status == index && 'active'}`}
          variant="contained"
          onClick={handleToggle}>
          {name} <span className="count">{count}</span>
        </ButtonMenu>

        <AnimatePresence>
          {open && (
            <SubMenu
              onClick={() => {
                if (openSubMenu) setOpenSubMenu(false);
              }}
              initial={{ y: -50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -50, opacity: 0 }}
              transition={{
                type: 'tween',
                duration: 0.2,
              }}>
              <div className="sub-menus-content">
                <ul>
                  {user?.technical_team?.channels
                    .filter((c) => !c.parent_id)
                    .map((channel) => {
                      if (true) {
                        if (
                          user?.technical_team === null ||
                          user?.role !== 3 ||
                          user?.technical_team?.channels?.some((c) => c.id === channel.id)
                        ) {
                          return (
                            <li className="item" key={channel.id} onClick={() => setChanelClick(channel.id)}>
                              <ItemSubMenu
                                clickMenu={chanelClick}
                                item={channel}
                                count={countChannel(channel) ?? 0}
                                openSubMenu={openSubMenu}
                                setOpenSubMenu={setOpenSubMenu}
                                action={
                                  !channel.custom
                                    ? () => {
                                        if (onChangeFlow != null) {
                                          localStorage.setItem(
                                            'pessego_attendance_flow',
                                            JSON.stringify(channel.attendance_flow.status_flow)
                                          );
                                          onChangeFlow(channel.attendance_flow.status_flow);
                                        }
                                        onClick(channel.id, null);
                                        setOpen(false);
                                        setOpenSubMenu(false);
                                      }
                                    : null
                                }>
                                {chanelClick === 1 && <GrupoCarbel />}
                                {chanelClick === 2 && channel.id == 2 ? (
                                  <Partners PartnersChildren={channel.children} />
                                ) : (
                                  ''
                                )}
                                {chanelClick === 3 && channel.id == 3 ? <Web WebChildren={channel.children} /> : ''}
                                {chanelClick === 21 && channel.id == 21 ? (
                                  <SubChannel subChildren={channel.children} />
                                ) : (
                                  ''
                                )}
                                {chanelClick > 3 && chanelClick != 21 && channel.children ? (
                                  <SubChannel subChildren={channel.children} />
                                ) : (
                                  ''
                                )}
                              </ItemSubMenu>
                            </li>
                          );
                        }
                      }
                    })}
                </ul>
              </div>
            </SubMenu>
          )}
        </AnimatePresence>
      </div>
      <Shadow
        onClick={() => {
          setOpen(false);
          setOpenSubMenu(false);
        }}
        open={open}
      />
    </>
  );
}

MenuButton.propTypes = {
  name: P.string.isRequired,
  status: P.number,
  index: P.number,
  count: P.number.isRequired,
  className: P.string.isRequired,
  user: P.objectOf(P.any),
  onClick: P.func.isRequired,
};

MenuButton.defaultProps = {
  user: null,
  status: 0,
};
